import { render, staticRenderFns } from "./ApplicationList.vue?vue&type=template&id=08a2d648&scoped=true&"
import script from "./ApplicationList.vue?vue&type=script&lang=js&"
export * from "./ApplicationList.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationList.vue?vue&type=style&index=0&id=08a2d648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a2d648",
  null
  
)

export default component.exports